import { Formik, Form, ErrorMessage } from 'formik';
import { useState, useEffect } from 'react';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { RadioButton } from 'primereact/radiobutton';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';

import useAddPage from 'hooks/useAddPage';
const ApplicationmasterAppstep1Page = (props) => {
		const auth = useAuth();
	const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		fullname: yup.string().required().label($t('fullname')),
		firstname: yup.string().required().label($t('firstname')),
		middlename: yup.string().nullable().label($t('middlename')),
		lastname: yup.string().required().label($t('lastname')),
		mobile: yup.string().required().label($t('mobile')),
		dob: yup.string().required().label($t('dob')),
		gender: yup.string().required().label($t('gender')),
		addrline1: yup.string().required().label($t('addrline1')),
		state: yup.string().required().label($t('state')),
		city: yup.string().required().label($t('city')),
		postal: yup.string().required().label($t('postal')),
		nationalid: yup.string().required().label($t('nationalid')),
		pancard: yup.string().nullable().label($t('pancard')),
		voterid: yup.string().nullable().label($t('voterid')),
		maritalstatus: yup.string().required().label($t('maritalstatus')),
		bank_accountnumber: yup.string().required().label($t('bankAccountNumber')),
		bank_ifsc: yup.string().required().label($t('bankIfsc')),
		userid: yup.number().nullable().label($t('userid')),
		app_date: yup.string().nullable().label($t('appDate'))
	});
	
	//form default values
	const formDefaultValues = {
		fullname: '', 
		firstname: '', 
		middlename: '', 
		lastname: '', 
		mobile: '', 
		dob: new Date(), 
		gender: '', 
		addrline1: '', 
		state: '', 
		city: '', 
		postal: '', 
		nationalid: '', 
		pancard: '', 
		voterid: '', 
		maritalstatus: '', 
		bank_accountnumber: '', 
		bank_ifsc: '', 
		userid: auth.userId, 
		app_date: new Date(), 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
	}
	
	//auto fill other inputs on fullname change
	async function fullnameAutoFill(e, formik, index) {
		formik.handleChange(e);
 const fullName = e.target.value.trim();
  const parts = fullName.split(/\s+/);
  let firstName = '';
  let middleName = '';
  let lastName = '';
  if (parts.length === 1) {
    firstName = parts[0];
  } else if (parts.length === 2) {
    [firstName, lastName] = parts;
  } else if (parts.length >= 3) {
    firstName = parts[0];
    lastName = parts[parts.length - 1];
    middleName = parts.slice(1, -1).join(' ');
  }
  await formik.setFieldValue(`firstname`, firstName);
  await formik.setFieldValue(`middlename`, middleName);
  await formik.setFieldValue(`lastname`, lastName);
	};
const [aadhaarNumber, setAadhaarNumber] = useState("");
    const [otp, setOtp] = useState("");
    const [referenceId, setReferenceId] = useState("");
    const [otpSent, setOtpSent] = useState(false);
    const [kycVerified, setKycVerified] = useState(false);
    const [loadingOTP, setLoadingOTP] = useState(false);
    const [loadingVerify, setLoadingVerify] = useState(false);
    const [timer, setTimer] = useState(60);
    const [canResend, setCanResend] = useState(false);
    const [showOtpDialog, setShowOtpDialog] = useState(false);
    const [kycData, setKycData] = useState(null);
    const [kycError, setKycError] = useState("");
        // Timer for OTP resend
    useEffect(() => {
        if (otpSent && timer > 0 && !canResend) {
            const countdown = setTimeout(() => {
                setTimer(prev => {
                    if (prev <= 1) {
                        setCanResend(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
            return () => clearTimeout(countdown);
        }
    }, [otpSent, timer, canResend]);
    // Validate Aadhaar number
    const validateAadhaar = (number) => {
        const regex = /^\d{12}$/;
        return regex.test(number);
    };
    // Send OTP to Aadhaar number
    const handleSendOTP = async () => {
        setKycError("");
        setLoadingOTP(true);
        if (!validateAadhaar(aadhaarNumber)) {
            setKycError("Please enter a valid 12-digit Aadhaar number");
            setLoadingOTP(false);
            return;
        }
        try {
            const response = await fetch(`${process.env.REACT_APP_API_PATH}sandbox/send-otp`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    entity: 'in.co.sandbox.kyc.aadhaar.okyc.otp.request',
                    aadhaar_number: aadhaarNumber,
                    consent: 'y',
                    reason: 'KYC'
                }),
            });
            const data = await response.json();
            if (response.ok) {
                setReferenceId(data.data.reference_id);
                setOtpSent(true);
                setShowOtpDialog(true);
                setTimer(60);
                setCanResend(false);
                setKycError("");
                // Update nationalid field in form
                await setFieldValue("nationalid", aadhaarNumber);
            } else {
                setKycError(data.message || "Failed to send OTP. Please try again.");
            }
        } catch (err) {
            setKycError("Network error. Please check your connection.");
            console.error("OTP Send Error:", err);
        } finally {
            setLoadingOTP(false);
        }
    };
    // Verify OTP
    const handleVerifyOTP = async () => {
        if (otp.length !== 6) {
            setKycError("Please enter 6-digit OTP");
            return;
        }
        setLoadingVerify(true);
        setKycError("");
        try {
            const response = await fetch('/api/sandbox/verify-otp', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    Entity: 'in.co.sandbox.kyc.aadhaar.okyc.request',
                    reference_id: referenceId,
                    otp: otp
                }),
            });
            const data = await response.json();
            if (response.ok) {
                setKycData(data);
                setKycVerified(true);
                setShowOtpDialog(false);
                // Auto-fill form fields with KYC data
                await autoFillForm(data.data);
                app.flashMsg("KYC Success", "Aadhaar KYC verified successfully!");
            } else {
                setKycError(data.message || "Invalid OTP. Please try again.");
            }
        } catch (err) {
            setKycError("Network error. Please try again.");
            console.error("OTP Verify Error:", err);
        } finally {
            setLoadingVerify(false);
        }
    };
    // Auto-fill form with KYC data
    const autoFillForm = async (kycInfo) => {
        try {
            // Name fields
            if (kycInfo.name) {
                const nameParts = kycInfo.name.split(/\s+/);
                let firstName = '';
                let middleName = '';
                let lastName = '';
                if (nameParts.length === 1) {
                    firstName = nameParts[0];
                } else if (nameParts.length === 2) {
                    [firstName, lastName] = nameParts;
                } else if (nameParts.length >= 3) {
                    firstName = nameParts[0];
                    lastName = nameParts[nameParts.length - 1];
                    middleName = nameParts.slice(1, -1).join(' ');
                }
                await setFieldValue("fullname", kycInfo.name);
                await setFieldValue("firstname", firstName);
                await setFieldValue("middlename", middleName);
                await setFieldValue("lastname", lastName);
            }
            // Date of Birth
            if (kycInfo.dob) {
                const dobParts = kycInfo.dob.split('-');
                if (dobParts.length === 3) {
                    // Convert DD-MM-YYYY to Date object
                    const dobDate = new Date(`${dobParts[2]}-${dobParts[1]}-${dobParts[0]}`);
                    await setFieldValue("dob", dobDate);
                }
            }
            // Gender
            if (kycInfo.gender) {
                const genderMap = {
                    'M': 'Male',
                    'F': 'Female',
                    'T': 'Transgender'
                };
                await setFieldValue("gender", genderMap[kycInfo.gender] || kycInfo.gender);
            }
            // Address fields
            if (kycInfo.full_address) {
                await setFieldValue("addrline1", kycInfo.full_address);
            }
            if (kycInfo.split_address) {
                const addr = kycInfo.split_address;
                await setFieldValue("state", addr.state || '');
                await setFieldValue("city", addr.vtc || addr.loc || '');
                await setFieldValue("postal", kycInfo.zip || '');
            }
            // Phone hash (you might want to handle this differently)
            if (kycInfo.phone_hash) {
                // Phone hash is not the actual phone number
                // You might want to prompt user to enter phone manually
            }
        } catch (error) {
            console.error("Error auto-filling form:", error);
        }
    };
    // Resend OTP
    const handleResendOTP = async () => {
        setLoadingOTP(true);
        setCanResend(false);
        setOtp("");
        setTimer(60);
        try {
            const response = await fetch('/api/sandbox/send-otp', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    entity: 'in.co.sandbox.kyc.aadhaar.okyc.otp.request',
                    aadhaar_number: aadhaarNumber,
                    consent: 'y',
                    reason: 'KYC'
                }),
            });
            const data = await response.json();
            if (response.ok) {
                setReferenceId(data.data.reference_id);
                setKycError("");
            } else {
                setKycError(data.message || "Failed to resend OTP");
                setCanResend(true);
            }
        } catch (err) {
            setKycError("Network error. Please try again.");
            setCanResend(true);
        } finally {
            setLoadingOTP(false);
        }
    };
    // Reset KYC flow
    const resetKYC = () => {
        setAadhaarNumber("");
        setOtp("");
        setReferenceId("");
        setOtpSent(false);
        setKycVerified(false);
        setKycData(null);
        setKycError("");
        setShowOtpDialog(false);
    };
    //auto fill other inputs on fullname change
    async function fullnameAutoFill(e, formik, index) {
        formik.handleChange(e);
        const fullName = e.target.value.trim();
        const parts = fullName.split(/\s+/);
        let firstName = '';
        let middleName = '';
        let lastName = '';
        if (parts.length === 1) {
            firstName = parts[0];
        } else if (parts.length === 2) {
            [firstName, lastName] = parts;
        } else if (parts.length >= 3) {
            firstName = parts[0];
            lastName = parts[parts.length - 1];
            middleName = parts.slice(1, -1).join(' ');
        }
        await formik.setFieldValue(`firstname`, firstName);
        await formik.setFieldValue(`middlename`, middleName);
        await formik.setFieldValue(`lastname`, lastName);
    };
    //event raised after form submit
    function afterSubmit(response){
        app.flashMsg(props.msgTitle, props.msgAfterSave);
        resetForm();
        if(app.isDialogOpen()){
            app.closeDialogs();
        }
        else if(props.redirect) {
            // Use ID from response
            app.navigate(`/applicationmaster/appstep2/${response.applicationid}`);
        }
    }
    // OTP Dialog
    const otpDialogFooter = (
        <div>
            <Button label="Cancel" icon="pi pi-times" onClick={() => setShowOtpDialog(false)} className="p-button-text" />
            <Button label="Verify" icon="pi pi-check" onClick={handleVerifyOTP} loading={loadingVerify} disabled={otp.length !== 6} />
        </div>
    );
    // page loading form data from api
    if(loading){
        return (
            <div className="p-3 text-center">
                <ProgressSpinner style={{width:'50px', height:'50px'}} />
            </div>
        );
    }
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="ApplicationmasterAppstep1Page" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('applicationStep1')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid ">
                <div className="col comp-grid" >
                    <div className="">
                        <div className="formgrid grid">
                            <div className="col-6 md:col-3">
                                <InputText name="aadhaarNumber"  label="AADHAR CARD" type="text" placeholder="Enter Aadhar Number" value={aadhaarNumber} onChange={(e) => setAadhaarNumber(e.target.value)} />
                            </div>
                            <div className="col-6 md:col-3">
                                <Button 
                                label="Get OTP" 
                                icon="pi pi-check" 
                                onClick={handleSendOTP} 
                                disabled={loading}
                                />
                            </div>
                            <div className="col-6 md:col-3">
                                <Button  className="p-button-primary" type="button" label="Verify Aadhar" icon="pi pi-send"  onClick={handleVerifyOTP}  disabled={loading} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="col comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('fullname')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="fullname"  onChange={(e)=>fullnameAutoFill(e, formik)}  value={formik.values.fullname}   label={$t('fullname')} type="text" placeholder={$t('enterFullname')}        className={inputClassName(formik?.errors?.fullname)} />
                                                <ErrorMessage name="fullname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('firstname')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="firstname"  onChange={formik.handleChange}  value={formik.values.firstname}   label={$t('firstname')} type="text" placeholder={$t('enterFirstname')}        className={inputClassName(formik?.errors?.firstname)} />
                                                <ErrorMessage name="firstname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('middlename')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="middlename"  onChange={formik.handleChange}  value={formik.values.middlename}   label={$t('middlename')} type="text" placeholder={$t('enterMiddlename')}        className={inputClassName(formik?.errors?.middlename)} />
                                                <ErrorMessage name="middlename" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('lastname')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="lastname"  onChange={formik.handleChange}  value={formik.values.lastname}   label={$t('lastname')} type="text" placeholder={$t('enterLastname')}        className={inputClassName(formik?.errors?.lastname)} />
                                                <ErrorMessage name="lastname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('mobile')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="mobile"  onChange={formik.handleChange}  value={formik.values.mobile}   label={$t('mobile')} type="text" placeholder={$t('enterMobile')}        className={inputClassName(formik?.errors?.mobile)} />
                                                <ErrorMessage name="mobile" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('dob')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="dob" showButtonBar className={inputClassName(formik?.errors?.dob)} dateFormat="yy-mm-dd" value={formik.values.dob} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="dob" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('gender')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className="flex flex-wrap">
                                                    {
                                                    app.menus.gender.map((option) => {
                                                    return (
                                                    <div key={option.value} className="field-radiobutton  mx-3">
                                                        <RadioButton inputId={option.value} name="gender" value={option.value} onChange={formik.handleChange}  checked={formik.values.gender === option.value} className={inputClassName(formik?.errors?.gender, '')} />
                                                        <label htmlFor={option.value}>{option.label}</label>
                                                    </div>
                                                    )
                                                    })
                                                    }
                                                </div>
                                                <ErrorMessage name="gender" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('addrline1')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="addrline1"  onChange={formik.handleChange}  value={formik.values.addrline1}   label={$t('addrline1')} type="text" placeholder={$t('enterAddrline1')}        className={inputClassName(formik?.errors?.addrline1)} />
                                                <ErrorMessage name="addrline1" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('state')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="state"  onChange={formik.handleChange}  value={formik.values.state}   label={$t('state')} type="text" placeholder={$t('enterState')}        className={inputClassName(formik?.errors?.state)} />
                                                <ErrorMessage name="state" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('city')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="city"  onChange={formik.handleChange}  value={formik.values.city}   label={$t('city')} type="text" placeholder={$t('enterCity')}        className={inputClassName(formik?.errors?.city)} />
                                                <ErrorMessage name="city" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('postal')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="postal"  onChange={formik.handleChange}  value={formik.values.postal}   label={$t('postal')} type="text" placeholder={$t('enterPostal')}        className={inputClassName(formik?.errors?.postal)} />
                                                <ErrorMessage name="postal" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('nationalid')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="nationalid"  onChange={formik.handleChange}  value={formik.values.nationalid}   label={$t('nationalid')} type="text" placeholder={$t('enterNationalid')}        className={inputClassName(formik?.errors?.nationalid)} />
                                                <ErrorMessage name="nationalid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('pancard')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pancard"  onChange={formik.handleChange}  value={formik.values.pancard}   label={$t('pancard')} type="text" placeholder={$t('enterPancard')}        className={inputClassName(formik?.errors?.pancard)} />
                                                <ErrorMessage name="pancard" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('voterid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="voterid"  onChange={formik.handleChange}  value={formik.values.voterid}   label={$t('voterid')} type="text" placeholder={$t('enterVoterid')}        className={inputClassName(formik?.errors?.voterid)} />
                                                <ErrorMessage name="voterid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('maritalstatus')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/maritalstatus_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="maritalstatus"     optionLabel="label" optionValue="value" value={formik.values.maritalstatus} onChange={formik.handleChange} options={response} label={$t('maritalstatus')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.maritalstatus)}   />
                                                    <ErrorMessage name="maritalstatus" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('bankAccountNumber')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="bank_accountnumber"  onChange={formik.handleChange}  value={formik.values.bank_accountnumber}   label={$t('bankAccountNumber')} type="text" placeholder={$t('enterBankAccountNumber')}        className={inputClassName(formik?.errors?.bank_accountnumber)} />
                                                <ErrorMessage name="bank_accountnumber" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('bankIfsc')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="bank_ifsc"  onChange={formik.handleChange}  value={formik.values.bank_ifsc}   label={$t('bankIfsc')} type="text" placeholder={$t('enterBankIfsc')}        className={inputClassName(formik?.errors?.bank_ifsc)} />
                                                <ErrorMessage name="bank_ifsc" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('userid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="userid"  onChange={formik.handleChange}  value={formik.values.userid}   label={$t('userid')} type="number" placeholder={$t('enterUserid')}  min={0}  step="any" disabled   className={inputClassName(formik?.errors?.userid)} />
                                                <ErrorMessage name="userid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('appDate')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="app_date" showButtonBar className={inputClassName(formik?.errors?.app_date)} dateFormat="yy-mm-dd" value={formik.values.app_date} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="app_date" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label={$t('nextStep')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
ApplicationmasterAppstep1Page.defaultProps = {
	primaryKey: 'applicationid',
	pageName: 'applicationmaster',
	apiPath: 'applicationmaster/appstep1',
	routeName: 'applicationmasterappstep1',
	submitButtonLabel: $t('nextStep'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('createRecord'),
	msgAfterSave: $t('recordAddedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default ApplicationmasterAppstep1Page;
